import { Link } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader, Section, Prose, Quote, Disclaimer } from "@/components/Editorial";

export default function HistoireEsoterisme() {
  useSeo({
    title: "Histoire & Ésotérisme",
    description: "L'histoire de l'ésotérisme : origine des pratiques, contexte historique, croyances populaires, cours royales, sociétés initiatiques, cartomancie, astrologie, spiritisme et magnétisme.",
    path: "/histoire-esoterisme",
  });

  const topics = [
    "origine des pratiques", "contexte historique", "croyances populaires", "cours royales",
    "artistes", "auteurs", "personnages historiques", "sociétés initiatiques", "mysticisme",
    "cartomancie", "astrologie", "chiromancie", "numérologie", "spiritisme", "magnétisme", "divination",
  ];

  return (
    <div>
      <PageHeader eyebrow="Page éditoriale" title="Histoire & Ésotérisme" image={IMG.map} tall />
      <div className="dl-container mt-6 mb-8 text-sm text-[#F3E9D2]/70">
Pour continuer l’exploration, découvrez aussi{" "}
<a href="/livres" className="dl-link">mes livres</a>,{" "}
<a href="/mediuminite" className="dl-link">la médiumnité</a> et{" "}
<a href="/les-chroniques-de-letrange" className="dl-link">
Les Chroniques de l’Étrange
</a>.
</div>
      <Section>
        <Prose>
          <p className="text-xl text-[#F3E9D2]">L'ésotérisme ne commence pas avec les réseaux sociaux.</p>
          <p>
            Derrière chaque pratique, il y a une origine, une époque, un usage et une évolution. Comprendre
            l'ésotérisme, c'est d'abord replacer les croyances et les gestes dans leur histoire — celle des
            sociétés qui les ont façonnés, transformés, parfois oubliés puis redécouverts.
          </p>
        </Prose>
        <Quote>« Avant de pratiquer, comprenons d'où ça vient. »</Quote>
        <div className="mt-10">
          <div className="dl-eyebrow mb-5">Ce que l'on explore</div>
          <div className="flex flex-wrap gap-2.5 max-w-4xl">
            {topics.map((t, i) => (
              <span key={i} className="px-4 py-2 text-sm border border-[rgba(198,167,106,0.25)] text-[#F3E9D2]/75 first-letter:capitalize">{t}</span>
            ))}
          </div>
        </div>
        <Disclaimer>Une croyance ou une tradition n'est jamais présentée ici comme un fait scientifiquement établi. On distingue toujours le fait, la croyance et la légende.</Disclaimer>
        <div className="mt-10"><Link to="/les-chroniques-de-letrange" className="dl-btn">Les Chroniques de l'Étrange</Link></div>
      </Section>
    </div>
  );
}
